/**
 * OffRadioPanel — Officer Radios panel.
 *
 * Thin wrapper around RadioSection with the officer-radio store slice.
 */
import { useDesktopStore } from '../../stores/desktop'
import RadioSection from './RadioSection'

export default function OffRadioPanel() {
  const { offRadios, setOffRadios } = useDesktopStore()
  return (
    <RadioSection
      radios={offRadios}
      setRadios={setOffRadios}
      title="Officer Radios"
      naType="Off Radio"
      officerVariant
    />
  )
}
